import MenuIcon from '@mui/icons-material/Menu';
const BurgerIcon = ({style,click}) => {
        
    return ( 
        <>
        {/* <div style={{width:"100%"}}> */}
            <div className={"companydetail__delete " + "delete__style"+style} onClick={click}>
                <MenuIcon/>
            </div>
        {/* </div> */}
            
        </>
     );
}
 
export default BurgerIcon;